"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _FormField = require("../FormField/FormField.context");
var _Label = require("./Label.styles");
var _excluded = ["disabled", "optional", "required", "size"];
var defaultProps = {
  size: _constants.LABEL_SIZES.md
};

/**
 * A native HTML [`<label>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/label).
 *
 * @related ['FormField', 'LabeledControl']
 * @since 3.0.0
 */
var Label = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  var _defaultProps$props = Object.assign({}, defaultProps, props),
    disabled = _defaultProps$props.disabled,
    optional = _defaultProps$props.optional,
    required = _defaultProps$props.required,
    size = _defaultProps$props.size,
    rest = (0, _objectWithoutProperties2.default)(_defaultProps$props, _excluded);
  var merged = Object.assign({}, defaultProps, (0, _react.useContext)(_FormField.FormFieldContext), props);
  return /*#__PURE__*/_react.default.createElement(_Label.StyledLabel, (0, _extends2.default)({
    ref: forwardedRef,
    id: merged.labelId,
    htmlFor: merged.controlId,
    "data-required": merged.required,
    "data-optional": merged.optional,
    "aria-disabled": merged.disabled,
    size: merged.size
  }, rest));
});
exports.Label = Label;
Label.displayName = 'Label';
Label.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Sets the native id attribute. Can also be set by a FormField parent.
   */
  id: _propTypes.default.string,
  /**
   * Sets the
   * [`for`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/label#Attributes)
   * attribute of the label, associating the label with a form control.
   * Can also be set by a FormField parent.
   */
  htmlFor: _propTypes.default.string,
  /**
   * Displays the label in a required state. Can also be inherited from a FormField parent.
   */
  required: _propTypes.default.bool,
  /**
   * Displays the label in a disabled state. Can also be inherited from a FormField parent.
   */
  disabled: _propTypes.default.bool,
  /**
   * Displays the label in an optional state. Can also be inherited from a FormField parent.
   */
  optional: _propTypes.default.bool,
  /**
   * Determines the size of the label.
   *
   * @since 6.7.0
   */
  size: _propTypes.default.oneOf(Object.values(_constants.LABEL_SIZES))
} : {};